const { server_ip }= require('../config');

export async function insertPrimaryRegistration(data){
    try {
        const response= await fetch(`${server_ip}/api2/pregistrations`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function fetchRegistrations(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api2/pregistrations/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function approveRegistration(token,id){
    try {
        const response= await fetch(`${server_ip}/api2/pregistrations/approve/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function rejectRegistration(token,id){
    try {
        const response= await fetch(`${server_ip}/api2/pregistrations/reject/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function resetPasswordAndSendEmail(token,email){
    try {
        const response= await fetch(`${server_ip}/api2/pregistrations/resend/onboard-email`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                email
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}